/** Namespace `appHome` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const appHome = {
  eyebrow: "Ứng dụng · {slug}",
  ownPages: "Màn riêng của app",
  metrics: "Số liệu của app này",
  metricsHint: "Mở màn Số liệu chung, đã chọn sẵn {name}. Trong màn đó có thể đổi sang « {allApps} ».",
} as const;
